import { Badge, CheckboxInput, NumberInput } from 'journey-ui'
import React, { useCallback, useContext } from 'react'
import { money, sum } from '../../helpers'
import { ItemPageContext } from '../../contexts/ItemPageContext'

interface Props {
  addon: Addon
  addonIsMaxed: boolean
  item: AddonItem
}

/* todo: use context for addon card. */
export const AddonItemRow: React.FC<Props> = ({ item: addonItem, addon, addonIsMaxed }) => {
  const { form, setForm } = useContext(ItemPageContext)
  const formItem = form.children.find((child) => child.addon_hash_id === addon.hash_id && child.size_name === addonItem.size_name && child.name === addonItem.name)

  const getFreeAvailable = useCallback(() => {
    const currentFreeCnt = sum(form.children.filter((i) => i.addon_hash_id === addon.hash_id).map((i) => i.free_quantity ?? 0))

    return Math.max(0, addon.free - currentFreeCnt)
  }, [addon.free, addon.hash_id, form.children])

  const onQuantityChange = (e) => {
    setForm((form) => {
      const newQuantity = parseInt(e.target.value, 10)
      // include our current free quantity on top of available (since they effect each other)
      const freeAvailable = (getFreeAvailable() + (formItem?.free_quantity ?? 0))
      const freeQuantity = Math.min(freeAvailable, newQuantity)
      const basePrice = addonItem.price

      const newChildren: ItemChild[] = form.children.map((a) => (a.addon_hash_id === addon.hash_id && a.name === addonItem.name && a.size_name === addonItem.size_name ? {
        hash_id: a.hash_id,
        size_name: a.size_name,
        addon_hash_id: addon.hash_id,
        name: a.name,
        price: (basePrice * (newQuantity - freeQuantity)),
        quantity: newQuantity,
        free_quantity: freeQuantity,
      } : a))

      return {
        ...form,
        children: newChildren,
      }
    })
  }

  const onAddonClick = useCallback((item) => {
    setForm((form) => {
      const newChildren: ItemChild[] = formItem ? form.children.filter((i) => i.name + i.size_name !== item.name + item.size_name) : [...form.children, {
        hash_id: item.hash_id,
        name: item.name,
        addon_hash_id: addon.hash_id,
        size_name: item.size_name,
        price: item.price * form.quantity,
        quantity: form.quantity,
        free_quantity: getFreeAvailable() > 0 ? 1 : 0,
      }]

      return {
        ...form,
        children: newChildren,
      }
    })
  }, [addon.hash_id, formItem, getFreeAvailable, setForm])

  const hasFreeLeft = formItem?.free_quantity > 0 || getFreeAvailable() > 0
  const isChecked = !!formItem

  return (
    <div className="flex items-center justify-between w-full space-x-2">
      <CheckboxInput
        disabled={addonIsMaxed && !isChecked}
        className="w-auto flex-grow flex-shrink"
        label={(
          <div className="flex items-center justify-between space-x-2">
            <span>{addonItem.name}</span>
            <Badge>
              {hasFreeLeft ? (
                <>
                  <s>
                    {money(addonItem.price)}
                  </s>
                  <span> - Free</span>
                </>
              ) : <>{money(addonItem.price)}</>}
            </Badge>
          </div>
        )}
        checked={isChecked}
        onClick={() => onAddonClick(addonItem)}
      />
      {formItem && (
        <NumberInput
          min="1"
          className="w-20"
          value={formItem?.quantity}
          onChange={onQuantityChange}
        />
      )}
    </div>
  )
}
